<script lang="ts">
    import type { DialogField } from "./dialog";

    export let field: DialogField;

</script>

<!----------------------------------------------------------------------------->

{#if field.type === "custom"}
    <svelte:component this={field.component} {field} {...field.props} />
{:else if field.type === "boolean"}
    <label>
        <span>{field.name}</span>
        <input type="checkbox" bind:checked={field.value} />
    </label>
{:else if field.type === "text"}
    <span class="text">{field.value}</span>
{:else if field.type === "html"}
    <span class="text">{@html field.value}</span>
{:else if field.type === "warning"}
    <div class="warning">
        <h4>WARNING</h4>
        <span>{field.value}</span>
    </div>
{:else}
    <label>
        <span>{field.name}</span>
        <input type="text" bind:value={field.value} />
    </label>
{/if}

<!----------------------------------------------------------------------------->

<style>
    label {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: span 2;
        align-items: center;
    }

    label:has(input[type="checkbox"]) {
        display: grid;
        grid-template-columns: 1fr max-content;
    }

    span {
        margin-right: 0.5rem;
    }

    .text {
        grid-column: span 2;
    }

    .warning {
        grid-column: span 2;
        padding-block: 0.25rem;
        border-left: 3px solid var(--warning);
        padding-left: 0.5rem;
        margin: 1rem 0 -1rem calc(-0.5rem - 3px);
        & h4 {
            margin: 0;
            font-weight: normal;
            color: var(--warning);
        }
    }

</style>
